import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '../../redux/hooks';
import { getAuthToken, getGuestModeFromStorage } from '../../helper/helper';
import { fetchAllLeagues } from '../myLeagues/api/myLeaguesApi';
import { fetchTeamsByTeamAdminId } from '../myTeam/api/myTeamApi';
import LiveMatchStrip from './sections/LiveMatchStrip';
import WelcomeSection from './sections/WelcomeSection';
import MatchCardsSection from './sections/MatchCardsSection';
// import NearYouSection from './sections/NearYouSection';
import CreateLeagueBanner from './sections/CreateLeagueBanner';
import PlatformBenefitsSection from './sections/PlatformBenefitsSection';
import SupportSection from './sections/SupportSection';
// import { DUMMY_MY_LEAGUES } from './constants/myLeaguesDummy';
// import { DUMMY_MY_TEAMS } from './constants/myTeamsDummy';
import MyLeaguesCarousel from './sections/MyLeaguesCarousel';
import MyTeamsSection from './sections/MyTeamsSection';
// import BlogsSection from './sections/BlogsSection';
// import Testimonials from '../homePage/testimonials/Testimonials';
import './LoggedInHomePage.scss';

const LoggedInHomePage: React.FC = () => {
  const token = getAuthToken();
  const isGuestModeRedux = useAppSelector((s) => s.authModal.isGuestMode);
  const isGuestUser = isGuestModeRedux || getGuestModeFromStorage();

  const { data: leagues = [] } = useQuery({
    queryKey: ['loggedHome', 'myLeagues', !!token],
    queryFn: fetchAllLeagues,
    enabled: !!token,
    staleTime: 30_000,
  });

  const { data: teams = [] } = useQuery({
    queryKey: ['loggedHome', 'myTeams', !!token],
    queryFn: () => fetchTeamsByTeamAdminId(),
    enabled: !!token,
    staleTime: 30_000,
  });

  const hasData = useMemo(
    () =>
      !!token &&
      ((!isGuestUser && leagues.length > 0) || teams.length > 0),
    [token, isGuestUser, leagues.length, teams.length]
  );

  // const displayLeagues = leagues.length > 0 ? leagues : DUMMY_MY_LEAGUES;
  // const displayTeams = teams.length > 0 ? teams : DUMMY_MY_TEAMS;

  return (
    <div className="logged-home-page">
      <LiveMatchStrip />
      <div className="logged-home-content">
        <WelcomeSection />
        {/* <MatchCardsSection /> */}
        {/* <NearYouSection />
        <CreateLeagueBanner />
        <MyLeaguesCarousel leagues={displayLeagues} />
        <MyTeamsSection teams={displayTeams} />
        <SupportSection />
        <PlatformBenefitsSection />
        <NearYouSection />
        <BlogsSection />
        <SupportSection /> */}

        {/* commented out sections for now for designing purpose */}

        {leagues.length > 0 && !isGuestUser && (
          <MyLeaguesCarousel leagues={leagues} />
        )}
        {teams.length > 0 && <MyTeamsSection teams={teams} />}
        {!hasData && (
          <>
            <CreateLeagueBanner />
            <SupportSection />
            <PlatformBenefitsSection />
          </>
        )}

        {/* {hasData && <NearYouSection />} */}
        {/* {hasData && <BlogsSection />}
         */}
        {hasData && <SupportSection />}
        {/* <Testimonials /> */}
      </div>
    </div>
  );
};

export default LoggedInHomePage;
